import { AxiosInstance } from 'axios'
import { User } from '../user'
import {
    ListResourceShareParams,
    PaginatedResourceShareResponse,
    ResourceShareBulkUpsertPayload,
    ResourceShareUserSearch,
} from './resource-share.type'

export class ResourceShareApi {
    constructor(private readonly client: AxiosInstance) {}

    async list(params: ListResourceShareParams): Promise<PaginatedResourceShareResponse> {
        const response = await this.client.get<PaginatedResourceShareResponse>('/resource-shares', {
            params,
        })
        return response.data
    }

    async bulkUpsert(payload: ResourceShareBulkUpsertPayload) {
        const response = await this.client.put('/resource-shares/bulk/upsert', payload)
        return response.data
    }

    async searchUsers(params: ResourceShareUserSearch): Promise<User[]> {
        const response = await this.client.get<User[]>('/resource-shares/users/search', {
            params,
        })
        return response.data
    }
}
